import React from "react";
import { Image, LinkBox, Box, Section, Text } from "@quarkly/widgets";
import { Override } from "@quarkly/components";

import articles from "../subpages/_articles_data";


const getFirstTwoArticleIdsByTag = (project_tag) => {
  // Filter articles based on the project_tag
  const filteredArticles = Object.entries(articles).filter(([id, article]) =>
    article.tags_projects.includes(project_tag)
  );
  // Get the first two article IDs from the filtered list
  const firstTwoArticleIds = filteredArticles.slice(0, 2).map(([id]) => id);
  return firstTwoArticleIds;
};

const ProjectsLatestArticles = ({ project_tag }) => {
  const firstTwoArticleIds = getFirstTwoArticleIdsByTag(project_tag);
  const firstArticle = articles[firstTwoArticleIds[0]];
  const secondArticle = articles[firstTwoArticleIds[1]];

  return (
    <>
      <Section
        padding="40px 0 40px 0"
        md-padding="20px 0 12px 0"
        quarkly-title="Section_LatestArticles_Content"
      >
        <Override
          slot="SectionContent"
          flex-direction="row"
          md-flex-wrap="wrap"
        />
        <Box
          empty-border-color="LightGray"
          padding="0px 20px 0px 0px"
          md-padding="0px 0px 0px 0px"
          md-width="100%"
          empty-min-width="64px"
          empty-border-style="solid"
          width="50%"
          empty-min-height="64px"
          empty-border-width="1px"
          align-items="center"
          display="flex"
          flex-direction="column"
          justify-content="flex-start"
          flex-wrap="no-wrap"
        >
          <LinkBox
            href={`/articles/${firstTwoArticleIds[0]}`}
            className="no-underline"
          >
            <Image
              object-fit="cover"
              lg-max-height="230px"
              src={firstArticle.image}
              max-height="400px"
              width="85%"
              height="100%"
              srcSet={`${firstArticle.image} 500w, ${firstArticle.image} 800w, ${firstArticle.image} 1080w, ${firstArticle.image} 1600w, ${firstArticle.image} 2000w, ${firstArticle.image} 2600w, ${firstArticle.image} 3200w`}
              sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
            />
            <Text
              sm-margin="24px 0px 16px 0px"
              margin="32px 0px 16px 0px"
              font="--lead"
              color="--green"
              lg-font='normal 600 20px/1.5 "Varta", sans-serif'
              md-margin="12px 0px 16px 0px"
            >
              {firstArticle.title}
            </Text>
            <Text
              margin="0px 0px 0px 0px"
              font="--base"
              color="--light"
              text-align="left"
              lg-font='normal 400 16px/1.5 "Varta", sans-serif'
              md-margin="0px 0px 32px 0px"
            >
              {firstArticle.shortDescription}
            </Text>
          </LinkBox>
        </Box>
        <Box
          empty-border-width="1px"
          empty-border-style="solid"
          width="50%"
          md-width="100%"
          md-padding="0px 0px 0px 0px"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-color="LightGray"
          padding="0px 0px 0px 20px"
          align-items="center"
          display="flex"
          flex-direction="column"
          justify-content="flex-start"
          flex-wrap="no-wrap"
        >
          <LinkBox
            href={`/articles/${firstTwoArticleIds[1]}`}
            className="no-underline"
          >
            <Image
              src={secondArticle.image}
              max-height="400px"
              width="85%"
              object-fit="cover"
              lg-max-height="230px"
              height="100%"
              srcSet={`${secondArticle.image} 500w, ${secondArticle.image} 800w, ${secondArticle.image} 1080w, ${secondArticle.image} 1600w, ${secondArticle.image} 2000w, ${secondArticle.image} 2600w, ${secondArticle.image} 3200w`}
              sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
            />
            <Text
              margin="32px 0px 16px 0px"
              font="--lead"
              color="--green"
              lg-font='normal 600 20px/1.5 "Varta", sans-serif'
              md-margin="12px 0px 16px 0px"
              sm-margin="24px 0px 16px 0px"
            >
              {secondArticle.title}
            </Text>
            <Text
              margin="0px 0px 0px 0px"
              font="--base"
              color="--light"
              lg-font='normal 400 16px/1.5 "Varta", sans-serif'
              text-align="left"
            >
              {secondArticle.shortDescription}
            </Text>
          </LinkBox>
        </Box>
      </Section>
    </>
  );
};

export default ProjectsLatestArticles;
